<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<QueryCondition @query="query" @exportExcel="exportExcel" ref="queryCondition" />
		
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<template v-if="row.status==2">
						<Button type="error" size="small" style="margin-right: 5px"
							@click="checkDraw(row.id,2)">拒绝</Button>
						<Button type="success" size="small" style="margin-right: 5px"
							@click="checkDraw(row.id,1)">通过</Button>
					</template>

				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>

	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition6'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,

			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						width: 200,
						title: '用户ID',
						key: 'userId',
						align: 'center',
						tooltip: true
					},
					{
						title: '提现金额',
						key: 'amount',
						align: 'center',
						tooltip: true
					}, {
						title: '状态',
						key: 'status',
						align: 'center',
						tooltip: true,
						render: (h, params) => {
							const status = params.row.status
							let txt = ""
							if (status == 1) {
								txt = "已完成"
							} else if (status == 2) {
								txt = "待审核"
							} else if (status == 3) {
								txt = "未通过"
							} else if (status == 4) {
								txt = "提现失败"
							}
							return h('span', txt);
						}
					}, {
						width: 180,
						title: '创建日期',
						key: 'createTime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			refreshData() {
				this.pageNum = 1,
				this.queryData = []
				this.getData()
			},
			getData() {
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.getNewVideoCheckList(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},

			checkDraw(id,status){
				const that=this
				api.statistics
					.newVideoCheckDraw({id:id,checkStatus:status})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = res.data.status
							}
						})
					})
					.catch(err => {
						this.$Message.error('审核失败失败: ' + err.message)
					})
			}
		},



	}
</script>
